
import React from 'react';
import { Box, Typography, styled, keyframes } from '@mui/material';
import useScrollTransition from '../useScrollTransition';


// Automatic 3D rotation animation
const rotateAnimation = keyframes`
  0% {
    transform: rotateY(0deg) rotateX(0deg);
  }
  50% {
    transform: rotateY(10deg) rotateX(5deg);
  }
  100% {
    transform: rotateY(0deg) rotateX(0deg);
  }
`;

// Wrapper for the entire component including overlay and collage
const CollageWrapper = styled(Box)({
  position: 'relative',
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor:"black"
  
});

// The background overlay
const BackgroundOverlay = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(35, 65, 82, 0.8)', // Dark transparent overlay
  zIndex: 3,
});

// Foreground text overlay centered in the container
const CenteredTextOverlay = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  color: '#fff',
  zIndex: 3, // Ensures it's on top
  textAlign: 'center',
  fontSize: '2.5rem',
  fontWeight: 700,
  '@media (max-width: 768px)': {
    fontSize: '2rem',
  },
  '@media (max-width: 480px)': {
    fontSize: '1.5rem',
  },
});

// Collage container for images that spans the full width of the screen
const CollageContainer = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(10, 1fr)',
  width: '100%', // Makes sure the collage spans full width
  height: '100%',
  position: 'relative',
  zIndex: 2, // Ensures the collage is between the two overlays
  '@media (max-width: 1024px)': {
    gridTemplateColumns: 'repeat(6, 1fr)',
  },
  '@media (max-width: 768px)': {
    gridTemplateColumns: 'repeat(4, 1fr)',
  },
  '@media (max-width: 480px)': {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
});

// Styles for each image with automatic 3D animation and no gap
const CollageImage = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'cover', // Ensures images cover their area neatly
  animation: `${rotateAnimation} 5s infinite ease-in-out`,
  border: 'none', // Removes any border or gap between images
});



const AboutLayout1: React.FC = () => {
  useScrollTransition();
  return (
    <CollageWrapper>
      {/* Background overlay */}
      <BackgroundOverlay />

      {/* Central text overlay */}
      <CenteredTextOverlay>
        <Typography variant="h3" color={'white'} component="h3" sx={{marginBottom:"10px"}} className='component'>
          About Us
        </Typography>
        <Typography color={'#bec5c9'}  className='component'>
        Connect With Us, We're Here to Help
        <br />Get in touch.
        </Typography>
      </CenteredTextOverlay>

      {/* Collage Container */}
      <CollageContainer>
        {/* Images arranged in a seamless grid with no gap */}
        <Box gridColumn="span 3">
          <CollageImage src="md1.jpg" alt="Office Meeting" className='component' />
        </Box>
        <Box gridColumn="span 4">
          <CollageImage src="md3.jpg" alt="Collaborative Workspace" className='component'  />
        </Box>

        <Box gridColumn="span 3">
          <CollageImage src="md2.jpg" alt="Working Team" className='component'  />
        </Box>
      
        
      </CollageContainer>
      
      
    </CollageWrapper>
    
    
  );
};

export default AboutLayout1;